import { Linking, Platform } from 'react-native';
import { useCallback } from 'react';
import {
  selectMarketingMeta,
  useSelector,
} from '@bonanza-social/toolkit/state';
import {
  selectAccountMarketingMeta,
  selectAccountMode,
} from '@bonanza-social/account/state';
import { Config } from '@bonanza-social/toolkit/config';
import { selectIsStatusAboveAmethyst } from '@bonanza-social/status/state';

function useTransmitResolver() {
  const accountMarketingMeta = useSelector(selectAccountMarketingMeta);
  const storedMarketingMeta = useSelector(selectMarketingMeta);
  const isStatusAboveAmethyst = useSelector(selectIsStatusAboveAmethyst);
  const accountMode = useSelector(selectAccountMode);

  const shouldTransmit = isStatusAboveAmethyst && !accountMode;

  const marketingMeta = storedMarketingMeta ?? accountMarketingMeta;

  const baseUrl = Config.ER_URL;
  const searchParamsString = Object.entries(marketingMeta)
    .map(([key, value]) => `${key}=${value}`)
    .join('&');

  const searchParams = new URLSearchParams(searchParamsString);

  const transmitter = `${baseUrl}?${searchParams}`;

  const handleTransmit = useCallback(() => {
    if (Platform.OS !== 'web') {
      Linking.openURL(transmitter);
    } else {
      window.location.href = transmitter;
    }
  }, [transmitter]);

  return {
    shouldTransmit,
    transmitter,
    handleTransmit,
  };
}

export default useTransmitResolver;
